module.exports = __webpack_public_path__ + "1a6d2b26a1435950079edee7a8f2f4c5.jpg";